module.exports = __webpack_public_path__ + "static/media/CircularStdBook.c8ae3e93.woff2";